import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { BUSINESS_TOOL_BASIC_NAME, HOME, LOGIN } from 'constants/paths';
import { uuidRegex } from 'constants/regex';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { addSearchParams } from 'helpers/addHash';

import { IProtectedRouteProps } from './types';

export const getIsBusinessToolPageLocation = (pathname: string) => {
  const [path, businessPlanId] = pathname.split('/').filter(Boolean);

  const isBusinessTool = path === BUSINESS_TOOL_BASIC_NAME;
  const isBusinessPlanId = Boolean(businessPlanId?.match(uuidRegex));

  return { isBusinessToolPageLocation: isBusinessTool && isBusinessPlanId, businessPlanId };
};

export const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isAuthConfiguring } = useAuthenticated();
  const { isBusinessToolPageLocation, businessPlanId } = getIsBusinessToolPageLocation(location.pathname);

  const isUserAuth = isAuthenticated || isAuthConfiguring;

  if (!isUserAuth && isBusinessToolPageLocation) {
    return <Navigate to={addSearchParams(LOGIN, `uuid=${businessPlanId}`)} replace />;
  }

  if (!isUserAuth) {
    return <Navigate to={HOME} state={{ from: location }} replace />;
  }

  return <>{children ?? <Outlet />}</>;
};
